var map = {
	"./de.mp4": 9511,
	"./mcg.mp4": 6096,
	"./mgdsl.mp4": 6906,
	"./ps.mp4": 8960,
	"./rts_wg.mp4": 1230,
	"./sci.mp4": 3471,
	"./sd.mp4": 5304,
	"./se.mp4": 6513,
	"./tbo.mp4": 4606,
	"./tbs.mp4": 9307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9354;